'use server'

import { signIn } from '../../../auth'
import { AuthError } from 'next-auth'

export async function loginAction(formData: FormData) {
  try {
    await signIn('credentials', {
      email: formData.get('email') as string,
      password: formData.get('password') as string,
      redirectTo: '/radovi/dashboard',
    })
  } catch (e) {
    if (e instanceof AuthError) {
      return { error: 'Invalid email or password.' }
    }
    // signIn throws a redirect — re-throw so Next.js can handle it
    throw e
  }
}
